var map = {
	"./noble01/防踢@2x.png": "3054",
	"./noble02/防踢@2x.png": "399c",
	"./noble03/防踢@2x.png": "c35e",
	"./noble04/防踢@2x.png": "db1c",
	"./noble05/防踢@2x.png": "4ae0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e596";